<template>
  <!-- 头部导航栏 -->
  <div class="smy__nav-box">
    <Col span="10">
      <div class="smy__nav-left">
        <div @click="_isVisibleSecondMenu">
          <Icon
            type="navicon"
            size="26"
            class="icon"
            :class="{'icon-rotate': !isVisibleSecondMenu}"
          ></Icon>
        </div>
        <Breadcrumb class="breadcrumb">
          <template v-for="(breadcrumb, index) in breadcrumbList">
            <BreadcrumbItem v-if="index == breadcrumbList.length - 1">
              {{breadcrumb.name}}
            </BreadcrumbItem>
            <BreadcrumbItem v-else :to="{ path: breadcrumb.path }">
              {{breadcrumb.name}}
            </BreadcrumbItem>
          </template>
        </Breadcrumb>
      </div>
    </Col>
    <Col span="14">
      <div class="smy__nav-right">
        <Dropdown
          trigger="click"
          placement="bottom-end"
          @on-click="dropDownFunc"
          >
          <a href="javascript:void(0)" class="avatar">
            <div class="" style="font-size: 16px;color: #3ccba6;margin-right:20px;">
              {{user.agentName}}
            </div>
            <div class="avatar-text">
              <div class="avatar-text-first smy__text-overflow-one-line">
                {{user.name}}
              </div>
              <div class="avatar-text-second">
                {{roleName}}
              </div>
            </div>
            <Icon
            type="arrow-down-b"
            class="nav-icon"
            ></Icon>
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="editAccount">个人信息</DropdownItem>
            <DropdownItem name="logout">退出登录</DropdownItem>
          </DropdownMenu>
        </Dropdown>

      </div>
    </Col>

    <EditAccountModal
      v-model="editAccountModalShow"
      />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

import EditAccountModal from './EditAccountModal'

export default {
  components: {
    EditAccountModal
  },
  data () {
    return {
      editAccountModalShow: false
    }
  },
  computed: {
    ...mapState('menu', [
      'breadcrumbList',
      'isVisibleSecondMenu',
      'thirdMenuList'
    ]),
    ...mapState('user', [
      'user'
    ]),
    roleName () {
      if (this.user.sysrole === 1) return '平台管理员'
      if (this.user.sysrole === 2) return '渠道经理'
      if (this.user.sysrole === 3) return '财务经理'
      if (this.user.sysrole === 4) return '代理商管理员'
      if (this.user.sysrole === 5) return '代理商业务员'
    }
  },
  watch: {
  },
  methods: {
    ...mapMutations('user', [
      '_user' // 同步筛选列
    ]),
    ...mapActions('menu', [
      '_DelAllTag',
      '_FirstMenuList',
      '_SecondMenuList',
      '_ThirdMenuList',
      '_AddTag'
    ]),
    ...mapMutations('menu', [
      '_isVisibleSecondMenu',
      '_menuIsLoadingOver',
      '_tag'
    ]),
    dropDownFunc (name) {
      if (name === 'editAccount') {
        this.editAccountModalShow = true
      } else if (name === 'logout') {
        this.$Modal.warning({
          title: '退出登录',
          content: '确认退出登录吗？',
          closable: true,
          onOk: () => {
            this.logoutFunc()
          }
        })
      }
    },
    logoutFunc () {
      this.$http.post('/logout').then(res => {
        if (res.success) {
          this.clearSessionFunc()
          this._user({})
          this.$router.push({ name: 'Login' })
        }
      })
    },
    clearSessionFunc () {
      this._DelAllTag()
      for (let key in sessionStorage) {
        if (key.indexOf('menu') !== -1) {
          sessionStorage.removeItem(key)
        }
      }
    }
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
@import '../assets/whole';


.smy__nav-box {
  height: 67px;
  display: flex;
  background: #FFF;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 6px #EDEDED;
  z-index: 89;

  .smy__nav-left {
    display: flex;
    align-items: center;

    .icon {
      margin: 0 15px 0 15px;
      transition: .5s;
      color: #80848F;
    }

    .icon:hover {
      cursor: pointer;
    }

    .icon-rotate {
      transform:rotate(-90deg);
    }
  }

  .smy__nav-right {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    // margin-right: 20px;

    .nav-icon {
      margin-right: 20px;
      color: #80848F;
    }
    .open-in-window {
      display: flex;
      width: 90px;
      flex-shrink: 0;
      color: #80848F;

      font {
        line-height: 26px;
        margin-left: 10px
      }
    }
    .nav-icon-hover:hover {
      color: #3ccba6;
      cursor: pointer;
    }

    @media screen and (min-width: 1339px) {
      .nav-input {
        width: 400px;
      }
    }

    .avatar {
      display: flex;
      align-items: center;
      color: #405060;

      .avatar-text {
        margin-left: 15px;
        width: 85px;
        margin-right: 5px;

        .avatar-text-first{
          font-size: 14px;
        }

        .avatar-text-second{
          font-size: 12px;
        }
      }
    }

  }
}

.role-change-modal {
  z-index: 10001;

  .modal-box {
    ul {
      display: flex;
      flex-wrap: wrap;

      li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 159px;
        height: 160px;
        margin-right: 10px;
        border-radius: 5px;
        margin-top: 10px;
        box-shadow: 0px 0px 8px rgba(204, 204, 204, 0.35);
        cursor: pointer;

        .role-icon {
          width: 51px;
          height: 80px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }

        .role-name {
          height: 30px;
          min-width: 1px;
          margin-top: 5px;
          font-size: 14px;
          color: #405060;
          text-align: center;
          line-height: 30px;
        }

        .role-label {
          height: 18px;
          min-width: 1px;
          font-size: 12px;
          color: #80848F;
          text-align: center;
        }
      }

      li:nth-child(4n) {
        margin-right: 0;
      }

      .active {
        background: -webkit-linear-gradient(left, @primary-color , @process-color); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(right, @primary-color, @process-color); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(right, @primary-color, @process-color); /* Firefox 3.6 - 15 */
        background: linear-gradient(to right, @primary-color , @process-color); /* 标准的语法 */

        .role-name {
          color: #fff;
        }

        .role-label {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/HeadNav.vue